export const UPDATE_AD_FILTERS = 'UPDATE_AD_FILTERS';
export const UPDATE_SEARCH_WORD = 'UPDATE_SEARCH_WORD';
export const CHECK_AD_FILTERS = 'CHECK_AD_FILTERS';

export function updateAdFilters(params) {
  return {
    type: UPDATE_AD_FILTERS,
    payload: {
      ...params,
    },
  };
}

export function updateSearchWord(params) {
  return {
    type: UPDATE_SEARCH_WORD,
    payload: {
      ...params,
    },
  };
}

export function checkAdFilters(prevState, nextState) {
  return {
    type: CHECK_AD_FILTERS,
    payload: {
      prevState,
      nextState,
    },
  };
}



// WEBPACK FOOTER //
// ./src/actions/filterAds.js